import { useState } from 'react'
import queryString from 'query-string'
import Box from '@talkdesk/cobalt-react-box'
import Divider from '@talkdesk/cobalt-react-divider'
import Link from '@talkdesk/cobalt-react-link'
import { Text } from '@talkdesk/cobalt-react-typography'
import {
  INVALID_CREDENTIALS_ERROR_TITLE,
  INVALID_CREDENTIALS_ERROR_ACTION
} from '../../constants/ui.labels'
import { INVALID_CREDENTIALS_HELP } from '../../constants/links'
import redirect from '../../utils/redirect'
import { OR } from '../../constants/ui.labels'
import Login from '../Login'
import IdentityProviders from '../../components/IdentityProviders'
import ErrorMessage from '../../components/ErrorMessage'

const LoginBody = ({
  brandAssetsURL,
  brandingSettings,
  localLoginEnabled,
  csrf,
  showCaptcha,
  siteKey,
  email,
  identityProviders,
  hasIdentityProviders
}) => {
  const [showError, setShowError] = useState(false)
  const [identityProvidersDisabled, setIdentityProvidersDisabled] = useState(
    false
  )

  const handleErrorChange = () => setShowError(true)

  const shouldShowError = () => {
    const queryParameters = queryString.parse(window.location.search) || {}
    return (
      showError ||
      Object.prototype.hasOwnProperty.call(queryParameters, 'error')
    )
  }

  const errorMessage = (
    <Link href={INVALID_CREDENTIALS_HELP(brandingSettings)}>
      {INVALID_CREDENTIALS_ERROR_ACTION}
    </Link>
  )

  const displayError = shouldShowError()

  return (
    <>
      {displayError ? (
        <ErrorMessage
          title={INVALID_CREDENTIALS_ERROR_TITLE}
          message={errorMessage}
        />
      ) : null}
      {localLoginEnabled ? (
        <Login
          csrf={csrf}
          showCaptcha={showCaptcha}
          siteKey={siteKey}
          email={email}
          redirect={redirect}
          handleErrorChange={handleErrorChange}
          setIdentityProvidersDisabled={setIdentityProvidersDisabled}
        />
      ) : null}
      {hasIdentityProviders && localLoginEnabled && (
        <Box paddingY={6}>
          <Divider>
            <Box as="span" paddingX={2}>
              <Text inline>{OR}</Text>
            </Box>
          </Divider>
        </Box>
      )}
      {hasIdentityProviders && (
        <IdentityProviders
          identityProviders={identityProviders}
          brandAssetsURL={brandAssetsURL}
          disabled={identityProvidersDisabled}
        />
      )}
    </>
  )
}

export default LoginBody
